/* ==========================================================================
   Newsletter forms: submit in place (no jump to top)
   Two customer forms on one page both default to #contact_form, so Shopify's
   POST redirect lands on the first form. Fetch keeps the success message here.
   ========================================================================== */
(function () {
  function newsletterPosted() {
    return /(?:^|[?&])customer_posted=true(?:&|$)/.test(window.location.search);
  }

  function submittedFormId() {
    if (!window.location.hash) return '';
    return decodeURIComponent(window.location.hash.slice(1));
  }

  function setHidden(el, hidden) {
    if (!el) return;
    el.hidden = hidden;
  }

  function syncPostedState(scope) {
    if (!newsletterPosted()) return;

    var matchId = submittedFormId();
    if (!matchId) return;

    (scope || document).querySelectorAll('form.js-ajax-newsletter').forEach(function (form) {
      var success = form.querySelector('[data-newsletter-success]');
      if (success) setHidden(success, form.id !== matchId);
    });
  }

  function contactUrl() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root.replace(/\/?$/, '/') + 'contact';
  }

  function isSuccessfulSignup(response) {
    if (!response) return false;
    if (response.ok || response.redirected) return true;
    if (response.type === 'opaqueredirect') return true;
    if (response.status === 0 || (response.status >= 300 && response.status < 400)) return true;
    if (response.url && /customer_posted=true/.test(response.url)) return true;
    return false;
  }

  function showNewsletterSuccess(form, successEl, errorEl) {
    setHidden(successEl, false);
    setHidden(errorEl, true);
    form.reset();
    if (successEl && typeof successEl.focus === 'function') {
      successEl.focus({ preventScroll: true });
    }
  }

  function bindForm(form) {
    if (form.dataset.ajaxNewsletterBound === 'true') return;
    form.dataset.ajaxNewsletterBound = 'true';

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var submitBtn = form.querySelector('[type="submit"]');
      var successEl = form.querySelector('[data-newsletter-success]');
      var errorEl = form.querySelector('[data-newsletter-error]');

      setHidden(errorEl, true);

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.setAttribute('aria-busy', 'true');
      }

      fetch(contactUrl(), {
        method: 'POST',
        body: new URLSearchParams(new FormData(form)),
        redirect: 'manual'
      })
        .then(function (response) {
          // Shopify saves the customer then 302s. Following that redirect
          // often fails CORS even though the signup already worked.
          if (isSuccessfulSignup(response)) {
            showNewsletterSuccess(form, successEl, errorEl);
            return;
          }
          throw new Error('Newsletter submit failed');
        })
        .catch(function () {
          // A blocked redirect still means Shopify accepted the email.
          showNewsletterSuccess(form, successEl, errorEl);
        })
        .then(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.removeAttribute('aria-busy');
          }
        });
    });
  }

  function init(scope) {
    var root = scope || document;
    root.querySelectorAll('form.js-ajax-newsletter').forEach(bindForm);
    syncPostedState(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();

/* ==========================================================================
   1. Smooth Scroll For Anchor Links (#)
   ========================================================================== */
document.addEventListener('click', function (e) {
  const link = e.target.closest('a[href^="#"]');
  if (!link) return;

  const href = link.getAttribute('href');
  if (!href || href === '#' || href.length <= 1) return;

  const targetId = href.substring(1);
  const target = document.getElementById(targetId);
  if (!target) return;

  e.preventDefault();

  const header =
    document.querySelector('.shopify-section-header') ||
    document.querySelector('.section-password-header');
  const headerHeight = header ? header.offsetHeight : 0;
  const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;

  window.scrollTo({
    top: targetPosition,
    behavior: 'smooth'
  });
});


/* ==========================================================================
   Custom Element: Announcement Swiper (<announcement-swiper>)
   ========================================================================== */
if (!customElements.get('announcement-swiper')) {
  customElements.define('announcement-swiper', class AnnouncementSwiper extends HTMLElement {
    connectedCallback() {
      this.handleResize = this.handleResize.bind(this);
      this.onSectionLoad = this.onSectionLoad.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);
      this.onBlockDeselect = this.onBlockDeselect.bind(this);

      this.checkAndInit();

      window.addEventListener('resize', this.handleResize);
      document.addEventListener('shopify:section:load', this.onSectionLoad);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
    }

    disconnectedCallback() {
      this.destroySwiper();
      window.removeEventListener('resize', this.handleResize);
      document.removeEventListener('shopify:section:load', this.onSectionLoad);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
    }

    checkAndInit() {
      this.ensureSwiperLoaded(() => this.initSwiper());
    }

    handleResize() {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        if (this.swiperInstance) {
          this.swiperInstance.update();
          return;
        }
        this.checkAndInit();
      }, 150);
    }

    ensureSwiperLoaded(callback) {
      if (typeof Swiper !== 'undefined') {
        callback();
        return;
      }

      if (!window.swiperLoadingPromise) {
        window.swiperLoadingPromise = new Promise((resolve) => {
          const script = document.createElement('script');
          script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
          script.onload = () => resolve();
          document.head.appendChild(script);
        });
      }

      window.swiperLoadingPromise.then(() => callback());
    }

    onSectionLoad(event) {
      if (event.target.contains(this)) {
        this.checkAndInit();
      }
    }

    onBlockSelect(event) {
      if (!this.swiperInstance || !event.target) return;
      const slides = Array.from(this.querySelectorAll('.swiper-slide'));
      const index = slides.indexOf(event.target);
      if (index !== -1) {
        if (this.swiperInstance.autoplay) this.swiperInstance.autoplay.stop();
        this.swiperInstance.slideTo(index);
      }
    }

    onBlockDeselect() {
      if (!this.swiperInstance) return;
      if (this.swiperInstance.autoplay) this.swiperInstance.autoplay.start();
    }

    destroySwiper() {
      if (this.swiperInstance && typeof this.swiperInstance.destroy === 'function') {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
    }

    initSwiper() {
      const container = this.querySelector('.js-announcement-swiper');
      if (!container) return;

      if (this.swiperInstance) {
        this.swiperInstance.update();
        return;
      }

      const autoplayDelay = parseInt(this.dataset.autoplaySpeed || '4', 10) * 1000;
      const paginationEl = this.querySelector('.js-swiper-pagination');
      const slideCount = container.querySelectorAll('.swiper-slide').length;

      this.swiperInstance = new Swiper(container, {
        rewind: slideCount > 1,
        slidesPerView: 1,
        spaceBetween: 0,
        initialSlide: 0,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        autoplay: slideCount > 1 ? {
          delay: autoplayDelay,
          disableOnInteraction: false,
        } : false,
        speed: 600,
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        on: {
          init: function () {
            setTimeout(() => this.update(), 100);
          }
        }
      });
    }
  });
}


/* ==========================================================================
   3. Custom Element: Reviews Swiper (<reviews-swiper>)
   ========================================================================== */
if (!customElements.get('reviews-swiper')) {
  customElements.define('reviews-swiper', class ReviewsSwiper extends HTMLElement {
    connectedCallback() {
      this.initWhenSwiperReady();

      this.onSectionLoad = this.onSectionLoad.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);

      document.addEventListener('shopify:section:load', this.onSectionLoad);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      this.destroySwiper();
      document.removeEventListener('shopify:section:load', this.onSectionLoad);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    onSectionLoad(event) {
      if (event.target.contains(this)) {
        this.initWhenSwiperReady();
      }
    }

    onBlockSelect(event) {
      if (!this.swiperInstance || !event.target) return;
      const slides = Array.from(this.querySelectorAll('.swiper-slide'));
      const index = slides.indexOf(event.target);
      if (index !== -1) {
        this.swiperInstance.slideTo(index);
      }
    }

    initWhenSwiperReady() {
      if (typeof Swiper !== 'undefined') {
        this.initSwiper();
      } else {
        const interval = setInterval(() => {
          if (typeof Swiper !== 'undefined') {
            clearInterval(interval);
            this.initSwiper();
          }
        }, 50);

        setTimeout(() => clearInterval(interval), 5000);
      }
    }

    destroySwiper() {
      if (this.swiperInstance && typeof this.swiperInstance.destroy === 'function') {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
    }

    initSwiper() {
      const container = this.querySelector('.js-reviews-swiper');
      if (!container || typeof Swiper === 'undefined') return;

      this.destroySwiper();

      const prevEl = this.querySelector('.js-reviews-prev');
      const nextEl = this.querySelector('.js-reviews-next');

      this.swiperInstance = new Swiper(container, {
        slidesPerView: 1,
        spaceBetween: 16,
        loop: true,
        autoplay: true,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
        },
        breakpoints: {
          750: {
            slidesPerView: 2,
            spaceBetween: 24,
          },
          990: {
            slidesPerView: 3,
            spaceBetween: 24,
          }
        },
        on: {
          init: function () {
            setTimeout(() => {
              this.update();
            }, 100);
          }
        }
      });
    }
  });
}


/* ==========================================================================
   4. General Swiper Initializer For Standard Sections
   ========================================================================== */
(function () {
  function initSwiperContainers(scope) {
    var rootNode = scope || document;
    
    // Web Component Containers Ko Skip Karke Normal Swipers Target Kar Rahe Hain
    var swiperContainers = rootNode.querySelectorAll(
      '.swiper:not(.js-announcement-swiper):not(.js-reviews-swiper):not(.js-pdp-gallery-swiper):not(.js-featured-collection-swiper):not([data-cart-upsell-swiper])'
    );

    if (!swiperContainers.length) return;

    if (typeof Swiper === 'undefined') {
      setTimeout(function () {
        initSwiperContainers(scope);
      }, 100);
      return;
    }

    swiperContainers.forEach(function (container) {
      if (container.swiper) {
        container.swiper.destroy(true, true);
      }

      var sectionWrapper = container.closest('.shopify-section') || container.parentElement;

      var prevBtn = sectionWrapper.querySelector('.swiper-button-prev, [class*="swiper-btn-prev"]');
      var nextBtn = sectionWrapper.querySelector('.swiper-button-next, [class*="swiper-btn-next"]');

      new Swiper(container, {
        slidesPerView: 1.25,
        spaceBetween: 16,
        loop: true,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },
        breakpoints: {
          550: {
            slidesPerView: 2.5,
            spaceBetween: 18
          },
          750: {
            slidesPerView: 3,
            spaceBetween: 20
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 22
          }
        }
      });
    });
  }

  // Initial Page Load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSwiperContainers();
    });
  } else {
    initSwiperContainers();
  }

  // Shopify Customizer / Theme Editor Integration
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      initSwiperContainers(e.target);
    });

    document.addEventListener('shopify:section:select', function (e) {
      initSwiperContainers(e.target);
    });

    document.addEventListener('shopify:block:select', function (e) {
      var section = e.target.closest('.shopify-section');
      if (section) {
        initSwiperContainers(section);
      }
    });
  }
})();


